import type { CityData } from "./cities-data.types";

export const CITY_CATALOG_D: CityData[] = [
  {
    slug: "haldwani",
    name: "Haldwani",
    name_hi: "हल्द्वानी",
    state: "Uttarakhand",
    latitude: 29.2183,
    longitude: 79.513,
    timezone: "Asia/Kolkata",
    regional_note:
      "Haldwani, the Gateway to Kumaon, is the last major plains city before the Kumaon Hills rise toward Nainital, Almora, and Ranikhet. Kali Chaur Temple at Biawan forest near Kathgodam is dedicated to Goddess Kali and offers a celebrated sunrise viewpoint, while Sheetla Mata Temple draws lakhs of pilgrims annually, especially during Navratri. Gayatri Shakti Peeth Temple adds to the town's spiritual character. The distinctively Kumaoni festivals Harela, Fuldeyi, and Ghee Sankranti are observed alongside Navratri and Dussehra. Panchang, choghadiya, and rahu kaal timings are computed for Haldwani's exact coordinates.",
    local_festivals: ["Navratri", "Harela", "Ghee Sankranti"],
  },
  {
    slug: "rudrapur",
    name: "Rudrapur",
    name_hi: "रुद्रपुर",
    state: "Uttarakhand",
    latitude: 28.9812,
    longitude: 79.4027,
    timezone: "Asia/Kolkata",
    regional_note:
      "Rudrapur takes its name from a Hindu legend in which King Rudra, whose chariot was trapped in swampland, built a temple to the goddess who freed him, and that shrine is today's Atariya Devi Mandir, where a ten-day Chaitra Navratri fair draws hundreds of thousands of pilgrims annually. Panch Mandir, a complex of five shrines 2 km from the city centre, sees major Janmashtami gatherings. As part of the Kumaon region, Rudrapur celebrates Harela, Ghee Sankranti, and Fuldeyi alongside Navratri and Diwali. Panchang, choghadiya, and rahu kaal timings are computed for Rudrapur's exact coordinates.",
    local_festivals: ["Chaitra Navratri (Atariya Devi Mela)", "Janmashtami", "Harela"],
  },
  {
    slug: "kedarnath",
    name: "Kedarnath",
    name_hi: "केदारनाथ",
    state: "Uttarakhand",
    latitude: 30.7346,
    longitude: 79.0669,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kedarnath, highest of the 12 Jyotirlingas at 3,583m, is accessible only from May to October due to snowfall. The Kedarnath Temple (Lord Shiva) reopens every year on Akshaya Tritiya — date fixed by precise Panchanga calculation. The Char Dham Yatra (Yamunotri, Gangotri, Kedarnath, Badrinath) begins and ends at Panchanga-prescribed auspicious muhurtas. Pilgrims consult panchang for safe, auspicious travel dates.",
    local_festivals: [
      "Kedarnath Opening (Akshaya Tritiya)",
      "Diwali (Closing Ceremony)",
      "Mahashivaratri",
    ],
  },
  {
    slug: "badrinath",
    name: "Badrinath",
    name_hi: "बद्रीनाथ",
    state: "Uttarakhand",
    latitude: 30.7433,
    longitude: 79.4938,
    timezone: "Asia/Kolkata",
    regional_note:
      "Badrinath, one of India's four sacred Dhams and home to the Badrinarayan Temple (Lord Vishnu), sits at 3,133m in the Chamoli district. The temple opens annually on Akshaya Tritiya (Panchanga-computed) and closes on Bhaidooj (day after Diwali). The Char Dham Yatra culminates here. The sacred Tapt Kund hot spring is used for ritual bathing before temple darshan. All puja timings are governed by the Badari Panchangam.",
    local_festivals: ["Char Dham Opening", "Badri Kedar Festival", "Diwali (Closing)"],
  },
  // Himachal Pradesh
  {
    slug: "dharamsala",
    name: "Dharamsala",
    name_hi: "धर्मशाला",
    state: "Himachal Pradesh",
    latitude: 32.219,
    longitude: 76.3234,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bhagsunag Temple, dedicated to Lord Shiva and the local Nag Devata, sits about 2 km above McLeodGanj at 6,900 feet and is Dharamsala's principal Hindu shrine, drawing devotees especially during Shravan. Dharamsala is equally renowned as the seat of the Tibetan government-in-exile and the Dalai Lama, and Namgyal Monastery in McLeodGanj gives the town a distinct Tibetan Buddhist character alongside its Hindu heritage. Chamunda Devi temple, an important Shakti shrine, lies 15 to 17 km away in the district. The Bhagsunag annual fair is held each September. Panchang, choghadiya, and rahu kaal timings are computed for Dharamsala's exact coordinates.",
    local_festivals: ["Bhagsunag Annual Fair (September)", "Navratri", "Diwali"],
  },
  {
    slug: "manali",
    name: "Manali",
    name_hi: "मनाली",
    state: "Himachal Pradesh",
    latitude: 32.2396,
    longitude: 77.1887,
    timezone: "Asia/Kolkata",
    regional_note:
      "Hadimba Devi Temple, a 1553 CE cedar-forest pagoda shrine dedicated to the Mahabharata goddess Hidimba, is Manali's most celebrated landmark and a designated heritage monument. Manu Rishi Temple, 3 km from Mall Road in Old Manali village, marks the legendary landing place of sage Manu after the great flood, and the city's very name derives from Manu Alaya. The Dhungri Mela, or Hadimba Devi Fair, in May and Navratri are the foremost Hindu festivals. Kullu Dussehra is held in Kullu, about 40 km south. Panchang, choghadiya, and rahu kaal timings are computed for Manali's exact coordinates.",
    local_festivals: ["Dhungri Mela (Hadimba Devi Fair)", "Navratri", "Maha Shivratri"],
  },
  {
    slug: "solan",
    name: "Solan",
    name_hi: "सोलन",
    state: "Himachal Pradesh",
    latitude: 30.9045,
    longitude: 77.0967,
    timezone: "Asia/Kolkata",
    regional_note:
      "Shoolini Mata Temple crowns Solan's identity, as the city itself takes its name from Goddess Shoolini, a fierce incarnation of Durga whose temple has presided over this hill town since ancient times. The Shoolini Fair, held every June for three days, draws thousands of pilgrims, traders, and performers with a grand palanquin procession of the Devi through Solan's streets accompanied by Nati folk dances, one of Himachal Pradesh's most distinctive annual melas. Navratri is the second major observance, and Jatoli Shiv Temple is also in the wider district. Panchang, choghadiya, and rahu kaal timings are computed for Solan's exact coordinates.",
    local_festivals: ["Shoolini Fair (June)", "Navratri", "Maha Shivratri"],
  },
  {
    slug: "mandi",
    name: "Mandi",
    name_hi: "मंडी",
    state: "Himachal Pradesh",
    latitude: 31.7048,
    longitude: 76.932,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mandi's 81 ancient stone temples earn it the title Chhoti Kashi, the Varanasi of the Hills. Bhutnath Temple, built by Raja Ajber Sen in 1527 CE at the town's heart, is the ceremonial starting point of the International Shivratri Fair. Panchvaktra Mahadev Temple at the confluence of the Suketi and Beas rivers, with its rare five-faced Shiva statue, is a declared National Heritage Site. The Mandi International Shivratri Fair draws over 200 village deities with their followers for a seven-day celebration each February and March. Panchang, choghadiya, and rahu kaal timings are computed for Mandi's exact coordinates.",
    local_festivals: ["International Shivratri Fair", "Navratri", "Diwali"],
  },
  // J&K and Ladakh
  {
    slug: "jammu",
    name: "Jammu",
    name_hi: "जम्मू",
    state: "Jammu & Kashmir",
    latitude: 32.7266,
    longitude: 74.857,
    timezone: "Asia/Kolkata",
    regional_note:
      "Raghunath Temple, the largest temple complex in North India, anchors Jammu's identity as the City of Temples. Built between 1835 and 1860 by the Dogra rulers Maharaja Gulab Singh and Maharaja Ranbir Singh, it enshrines idols of Ram, Sita, and Lakshman and celebrates Ram Navami and Dussehra with grand pomp. The Ranbireshwar Temple on Shalamar Road and the Peer Khoh cave shrine are further in-city landmarks. Jammu serves as the gateway for pilgrims to Vaishno Devi, whose shrine at Katra is approximately 49 km away. Panchang, choghadiya, and rahu kaal timings are computed for Jammu's exact coordinates.",
    local_festivals: ["Ram Navami (Raghunath Temple)", "Dussehra", "Maha Shivratri"],
  },
  {
    slug: "leh",
    name: "Leh",
    name_hi: "लेह",
    state: "Ladakh",
    latitude: 34.1526,
    longitude: 77.5771,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ram Mandir near Leh's Main Bazaar, built in the 20th century, is the principal Hindu temple for the small Hindu community in this predominantly Buddhist region. During Ram Navami the temple hosts special pujas, drawing devotees from across Leh's migrant and resident Hindu households. Diwali and Janmashtami are observed within the community. Buddhist monasteries dominate Ladakh's religious landscape, and Hindu temple presence in Leh itself is genuinely limited. Panchang, choghadiya, and rahu kaal timings are computed for Leh's exact coordinates.",
    local_festivals: ["Ram Navami", "Diwali", "Janmashtami"],
  },
  {
    slug: "katra",
    name: "Katra",
    name_hi: "कटरा",
    state: "Jammu & Kashmir",
    latitude: 32.992,
    longitude: 74.9318,
    timezone: "Asia/Kolkata",
    regional_note:
      "Katra is the base camp for the Vaishno Devi pilgrimage — India's second most visited religious site after Tirupati with 8–10 million annual pilgrims. The 13km trek to the cave shrine is begun at an auspicious muhurta (Panchang-computed, available at the yatra registration counter). The cave houses the sacred Pindies (natural rock formations) of Mata Vaishno Devi. Navratri sees the highest pilgrim density — auspicious muhurtas are especially critical during this period.",
    local_festivals: ["Navratri", "Diwali", "Ram Navami"],
  },
  // Northeast India
  {
    slug: "shillong",
    name: "Shillong",
    name_hi: "शिलांग",
    state: "Meghalaya",
    latitude: 25.5788,
    longitude: 91.8933,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mahadev Khola Dham, a cave Shiva temple about 4 km from Shillong's bus stand and over 150 years old, is Meghalaya's most distinctive Hindu pilgrimage site: a natural shivling discovered in situ during construction forms its sanctum, and Maha Shivaratri draws more than 25,000 devotees to a three-day mela. Matri Mandir, the Ramna Kalibari dedicated to Goddess Kali and revered by Shillong's Bengali community, hosts Navratri and Kali Puja. Durga Puja is celebrated across the city with large pandals. Panchang, choghadiya, and rahu kaal timings are computed for Shillong's exact coordinates.",
    local_festivals: ["Maha Shivaratri", "Durga Puja", "Kali Puja"],
  },
  {
    slug: "agartala",
    name: "Agartala",
    name_hi: "अगरतला",
    state: "Tripura",
    latitude: 23.8315,
    longitude: 91.2868,
    timezone: "Asia/Kolkata",
    regional_note:
      "Jagannath Bari, set within the Ujjayanta Palace grounds in central Agartala and built by the Manikya rulers, is the city's foremost temple, and its Rath Yatra draws hundreds of devotees each year. Tripura Sundari temple at Matabari, Udaipur, a 51 Shakti Peetha and one of India's most revered goddess shrines, lies 55 km away. Durga Puja is Tripura's grandest communal festival, celebrated at hundreds of pandals across Agartala. Kharchi Puja, unique to Tripura's royal tradition, and Diwali are also observed widely. Panchang, choghadiya, and rahu kaal timings are computed for Agartala's exact coordinates.",
    local_festivals: ["Durga Puja", "Rath Yatra", "Kharchi Puja"],
  },
  {
    slug: "imphal",
    name: "Imphal",
    name_hi: "इम्फाल",
    state: "Manipur",
    latitude: 24.817,
    longitude: 93.9368,
    timezone: "Asia/Kolkata",
    regional_note:
      "Shree Shree Govindajee Temple in the precincts of the royal palace, built in 1846 by Maharaja Nara Singh and rebuilt in 1876, is Manipur's premier Vaishnava shrine, housing Krishna-Radha, Jagannath, Balabhadra, and Subhadra under twin gold-plated domes. Three Ras Lilas performed here on full-moon nights in spring and autumn are a defining cultural event of Imphal. Yaoshang, Manipur's five-day Holi across the Meitei lunar calendar, draws the entire valley, and Kang, the Rath Yatra, sees a grand chariot procession each July. Panchang, choghadiya, and rahu kaal timings are computed for Imphal's exact coordinates.",
    local_festivals: ["Ras Lila", "Yaoshang (Holi)", "Kang (Rath Yatra)"],
  },
  {
    slug: "aizawl",
    name: "Aizawl",
    name_hi: "आइज़ोल",
    state: "Mizoram",
    latitude: 23.7271,
    longitude: 92.7176,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mizoram is over 87 percent Christian, and Hindu presence in Aizawl is concentrated within the small Gorkha and Bengali migrant communities. The Assam Rifles Hari Mandir at Canteen Square is the most prominent Hindu temple in the city and has served the community for over 70 years, and five additional temples in Aizawl are managed by the Central Gorkha Mandir Sanchalan Samiti. Durga Puja, Janmashtami, and Diwali are celebrated here, serving a Hindu population of under 3 percent of the state. Panchang, choghadiya, and rahu kaal timings are computed for Aizawl's exact coordinates.",
    local_festivals: ["Durga Puja", "Janmashtami", "Diwali"],
  },
  {
    slug: "kohima",
    name: "Kohima",
    name_hi: "कोहिमा",
    state: "Nagaland",
    latitude: 25.6751,
    longitude: 94.1086,
    timezone: "Asia/Kolkata",
    regional_note:
      "Nagaland is over 90 percent Christian, yet Kohima has an established Hindu community centred on two verified in-city temples. Durgabari Mandir in PWD Colony, housing shrines of Durga, Kali, and Shiva, was built by the Hindu residents of Kohima as a community worship centre, and Kalibari Temple in the city centre is dedicated to Goddess Kali. Both temples observe Durga Puja and Kali Puja with evening arati and cultural programmes, and Navratri is also marked within the community. Panchang, choghadiya, and rahu kaal timings are computed for Kohima's exact coordinates.",
    local_festivals: ["Durga Puja", "Kali Puja", "Navratri"],
  },
  {
    slug: "gangtok",
    name: "Gangtok",
    name_hi: "गंगटोक",
    state: "Sikkim",
    latitude: 27.3314,
    longitude: 88.6138,
    timezone: "Asia/Kolkata",
    regional_note:
      "Thakurbari Temple, established in 1935 on land gifted by the erstwhile Chogyal of Sikkim, sits at the heart of Gangtok and brings together shrines of all major Hindu deities under one complex. Hanuman Tok, a Hanuman temple at 7,200 feet maintained by the Indian Army, offers panoramic Himalayan views alongside daily worship. Chhath Puja is observed with particular devotion in Gangtok's Nepali Hindu community, alongside Maha Shivaratri, Bala Chaturdashi, and Tihar, Sikkim's local name for Diwali. Panchang, choghadiya, and rahu kaal timings are computed for Gangtok's exact coordinates.",
    local_festivals: ["Chhath Puja", "Tihar (Diwali)", "Maha Shivaratri"],
  },
  {
    slug: "itanagar",
    name: "Itanagar",
    name_hi: "ईटानगर",
    state: "Arunachal Pradesh",
    latitude: 27.0844,
    longitude: 93.6053,
    timezone: "Asia/Kolkata",
    regional_note:
      "Hindus form the largest single religious community in Itanagar, and the city's temples reflect this: Ganga Jamuna Mandir in Upper Chimi and Rajdhani Kali Mandir are the principal places of worship. Durga Puja is observed at over 36 pandals across the Itanagar Capital Complex, among the largest Hindu festivals in the northeast. Janmashtami draws thousands to the city's Krishna temples, and Rath Yatra and Navratri are observed with community processions. The indigenous Donyi-Polo tradition coexists with Hindu practice across Arunachal's tribal communities. Panchang, choghadiya, and rahu kaal timings are computed for Itanagar's exact coordinates.",
    local_festivals: ["Durga Puja", "Janmashtami", "Rath Yatra"],
  },
  {
    slug: "dibrugarh",
    name: "Dibrugarh",
    name_hi: "डिब्रूगढ़",
    state: "Assam",
    latitude: 27.4728,
    longitude: 94.912,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mahaprabhu Jagannath Temple in Dibrugarh's Khanikar locality, built as an 85-foot replica of the Puri Jagannath Mandir and consecrated in 2014, is one of northeast India's most striking temples, with seven shrines within its walled compound including Shiva, Ganesha, Hanuman, and Navagraha mandirs. Rath Yatra is the temple's signature festival, drawing large crowds each year. Bohag Bihu, Assam's spring harvest celebration, and Durga Puja are observed widely across Dibrugarh. Panchang, choghadiya, and rahu kaal timings are computed for Dibrugarh's exact coordinates.",
    local_festivals: ["Rath Yatra", "Bohag Bihu", "Durga Puja"],
  },
  {
    slug: "silchar",
    name: "Silchar",
    name_hi: "सिलचर",
    state: "Assam",
    latitude: 24.8333,
    longitude: 92.7789,
    timezone: "Asia/Kolkata",
    regional_note:
      "ISKCON Silchar in Ambikapatty is the city's most prominent active temple, dedicated to Lord Krishna and a major pilgrimage draw in the Barak Valley. Shyamsundar Mandir and Siddheshwar Mandir serve the Bengali Hindu community in town. Kachakanti Mandir at Udharbond, about 15 km from Silchar, is the region's oldest temple, founded in 1806 by a Kachari ruler and dedicated to a goddess combining the powers of Durga and Kali. Durga Puja and Kali Puja are celebrated with Barak-valley fervour. Panchang, choghadiya, and rahu kaal timings are computed for Silchar's exact coordinates.",
    local_festivals: ["Durga Puja", "Kali Puja", "Janmashtami"],
  },
  {
    slug: "jorhat",
    name: "Jorhat",
    name_hi: "जोरहाट",
    state: "Assam",
    latitude: 26.7509,
    longitude: 94.2037,
    timezone: "Asia/Kolkata",
    regional_note:
      "Jorhat's Ram Mandir in Fancy Bazar is the primary in-town Hindu temple, serving the city's Vaishnava community. Dhekiakhowa Bornamghar, about 15 km east of Jorhat town, was founded by saint-reformer Madhavdeva in 1461 and famously houses an earthen oil lamp said to have burned continuously for over five centuries. The satras of nearby Majuli island, the world's largest river island and a sub-division of Jorhat district, sustain the Sattriya Vaishnavism tradition of Srimanta Sankardev. Bohag Bihu, Kati Bihu, and Janmashtami mark the calendar. Panchang, choghadiya, and rahu kaal timings are computed for Jorhat's exact coordinates.",
    local_festivals: ["Bohag Bihu", "Janmashtami", "Doljatra"],
  },
  // Goa
  {
    slug: "panaji",
    name: "Panaji",
    name_hi: "पणजी",
    state: "Goa",
    latitude: 15.4909,
    longitude: 73.8278,
    timezone: "Asia/Kolkata",
    regional_note:
      "Shree Mahalaxmi Temple, built in 1818 on Church Square, is the officiating deity temple of Panaji, and Mahalaxmi is considered the presiding goddess of the city. Shree Maruti Temple on the Altinho hillside is home to the city's only zatra, a vibrant ten-day fair first held in 1944 with a grand palanquin procession. Panaji hosts one of Goa's most elaborate Shigmo parades along MG Road each February and March. Famous Goan temples like Mangueshi and Shantadurga are in Ponda, about 30 km away, relocated during the Portuguese period. Panchang, choghadiya, and rahu kaal timings are computed for Panaji's exact coordinates.",
    local_festivals: ["Shigmo", "Ganesh Chaturthi (Chavath)", "Maruti Zatra"],
  },
  {
    slug: "margao",
    name: "Margao",
    name_hi: "मडगाव",
    state: "Goa",
    latitude: 15.2832,
    longitude: 73.9862,
    timezone: "Asia/Kolkata",
    regional_note:
      "Margao, also called Madgaon, is the commercial capital of South Goa and a historic Gowda Saraswat Brahmin heartland. The Damodar Sal in the Saal locality and Hari Mandir are in-city Hindu shrines, while the celebrated Shri Damodar temple originally stood in Madgaon but was relocated to Zambaulim 22 km away during the Portuguese inquisition of the 1560s, where devotees from Margao still attend its Shigmo Gulal festival. Ganesh Chaturthi, locally Chavath, is the foremost Hindu celebration, observed for ten days across GSB households. Shigmo processions also pass through Margao's streets. Panchang, choghadiya, and rahu kaal timings are computed for Margao's exact coordinates.",
    local_festivals: ["Ganesh Chaturthi (Chavath)", "Shigmo", "Damodar Gulal at Zambaulim"],
  },
  // Puducherry
  {
    slug: "puducherry",
    name: "Puducherry",
    name_hi: "पुदुचेरी",
    state: "Puducherry",
    latitude: 11.9346,
    longitude: 79.8083,
    timezone: "Asia/Kolkata",
    regional_note:
      "Arulmigu Manakula Vinayagar Temple, one of Puducherry's oldest Ganesha shrines predating French rule, anchors the town's Hindu life and draws thousands during its golden chariot procession. Sri Aurobindo Ashram, founded in 1926, blends Vedic spirituality with the city's Franco-Tamil identity. Villianur's Gokilambal Thirukameswarar temple, with a Chola-era sanctum, stands about 8 km north. Masi Magam sees some thirty sacred images processed to the sea in dawn rituals. Panchang, choghadiya, and rahu kaal timings are computed for Puducherry's exact coordinates.",
    local_festivals: ["Masi Magam", "Karthigai Deepam", "Manakula Vinayagar Car Festival"],
  },
];
